import React from 'react';
import {
  StandardInputBaseProps,
  inputContainerStyles,
  labelStyles,
  requiredIndicatorStyles,
  getInputClassName,
} from './StandardInputStyles';

interface Props extends Omit<StandardInputBaseProps, 'value'> {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
  disabled?: boolean;
}

export default function StandardInputFile({
  id,
  label,
  isRequired,
  placeholderText,
  onChange,
  accept,
  disabled = false,
}: Props) {
  return (
    <div className={inputContainerStyles}>
      <label htmlFor={id} className={labelStyles}>
        {label}
        {isRequired && <span className={requiredIndicatorStyles}>*</span>}
      </label>
      <input
        type='file'
        id={id}
        accept={accept}
        placeholder={placeholderText ?? ''}
        className={getInputClassName('file')}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
}
